import PropTypes from 'prop-types'
import { Redirect, Route, withRouter } from 'react-router-dom'
import { useIsLogged } from 'signup/hooks/context/IsLoggedContext.js'
function PrivateRoute ({ component: Component, ...rest }) {
  const { isLogged } = useIsLogged()

  return (
    <Route
      {...rest}
      render={props =>
        isLogged ? <Component {...props} /> : <Redirect to="/" />
      }
    />
  )
}

PrivateRoute.propTypes = {
  component: PropTypes.elementType
}

export default withRouter(PrivateRoute)
